const logcat = (Prism) => {
  Prism.languages.logcat = {
    timestamp: /^[\d\s.:-]+?(?=[A-Z])/gm,
  };
};

logcat.displayName = 'logcat';
logcat.aliases = [];

export default logcat;
